import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'software-releases-version-detail.header.connect-apps.error-title',
		defaultMessage: "We weren't able to load {appName}.",
		description: 'Title of the error flag when rendering marketplace app failed.',
	},
	errorDescription: {
		id: 'software-releases-version-detail.header.connect-apps.error-description',
		defaultMessage: 'Please refresh the page to try again.',
		description: 'Description of the error flag when rendering marketplace app failed.',
	},
});
